import { PillBadge } from '@platform/components';

export const PillsList = ({ items }: { items: string[] }) => {
  return (
    <div className='flex flex-wrap gap-2'>
      {items.map((item) => (
        <PillBadge key={`pill-${item}`} variant='plain' color='gray' size='lg'>
          {item}
        </PillBadge>
      ))}
    </div>
  );
};
